module.exports = __webpack_public_path__ + "static/media/Logo_KC21-short.be6c5ab3.svg";